import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

/**
 * PublicLayout wraps public routes and always renders the public marketing navbar
 * regardless of authentication status.
 */
function PublicLayout() {
  const location = useLocation();
  const hideFooterPaths = ['/login', '/register'];
  const shouldHideFooter = hideFooterPaths.includes(location.pathname);

  return (
    <>
      <Header />
      <Outlet />
      {!shouldHideFooter && <Footer />}
    </>
  );
}

export default PublicLayout;
